import { render, staticRenderFns } from "./PricesModule.vue?vue&type=template&id=ea8c89ae&"
import script from "./PricesModule.vue?vue&type=script&lang=js&"
export * from "./PricesModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports